import { baseBuild } from '@/core/services/network/config/baseBuild';
import type { AppDispatch } from '@/app/store/store';
import { createMatchingSetService } from '../application/services/MatchingSetService';
import { MatchingSetAdapter } from '../infra/adapters/matchingSet.adapter';

export function matchingSetsBuild(dispatch: AppDispatch) {
  return baseBuild(
    (d: AppDispatch) => new MatchingSetAdapter(d),
    (repo) => createMatchingSetService(repo),
    dispatch,
  );
}
